import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

const filterE3PdfPageSelectionSchema = z.object({
  client_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  page_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_view_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_workbook_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterE3PdfPageSelectionSchema = z.infer<
  typeof filterE3PdfPageSelectionSchema
>;

const fields: Field[] = [
  {
    name: "client_contains",
    label: `Client`,
    type: "asyncAutocomplete",
    base_url: "e3/e3_pdf_page_selection",
    column_name: "client",
  },
  {
    name: "page_name_contains",
    label: `Nom de la page`,
    type: "asyncAutocomplete",
    base_url: "e3/e3_pdf_page_selection",
    column_name: "page_name",
  },
  {
    name: "tableau_view_contains",
    label: `Vue Tableau`,
    type: "asyncAutocomplete",
    base_url: "e3/e3_pdf_page_selection",
    column_name: "tableau_view",
  },
  {
    name: "tableau_workbook_id_contains",
    label: `ID du classeur Tableau`,
    type: "asyncAutocomplete",
    base_url: "e3/e3_pdf_page_selection",
    column_name: "tableau_workbook_id",
  },
  {
    name: "created_at",
    type: "dateRange",
    label: "Date de création",
    from: { name: "created_at_from" },
    to: { name: "created_at_to" },
  },
];

const client = "e3";

export function E3PdfPageSelectionFilter() {
  return (
    <FilterTable
      client={client}
      schema={filterE3PdfPageSelectionSchema}
      tableName="e3_pdf_page_selection"
      fields={fields}
    />
  );
}
